import { IGroupAlert } from '../types/clubProfile';

export class GroupAlert {
  userId: string | undefined;
  dateCreated: string | undefined;
  typeId: string | undefined;
  contentItem?: {
    approvalState: string;
    id: string;
    parentType: string;
    eventInterestExpressed: boolean;
    isMemberLike: boolean;
    classification: string;
    title: string;
    owner: {
      userId: string;
      userName: string;
      memberType: number;
    }
  }

  static mappingObject = (alert: any) => {
    let _group: IGroupAlert = {
      userId: alert.UserID,
      dateCreated: alert.DateCreated,
      typeId: alert.TypeID,
      contentItem: {
        approvalState: '',
        id: '',
        parentType: '',
        eventInterestExpressed: false,
        isMemberLike: false,
        classification: '',
        title: '',
        owner: {
          userId: '',
          userName: '',
          memberType: 0,
        }
      },
    };
    if (alert.ContentItem) {
      _group.contentItem = {
        approvalState: alert.ContentItem.ApprovalState,
        id: alert.ContentItem.ID,
        parentType: alert.ContentItem.ParentType,
        eventInterestExpressed: alert.ContentItem.EventInterestExpressed,
        isMemberLike: alert.ContentItem.IsMemberLike,
        classification: alert.ContentItem.Classification,
        title: alert.ContentItem?.Owner?.Username,
        owner: {
          userId: alert.ContentItem?.Owner?.UserID || '',
          userName: alert.ContentItem?.Owner?.Username || '',
          memberType: alert.ContentItem?.Owner?.MemberType || 0,
        }
      };
    }
    return _group;
  };
  static mappingObjects = (alerts: any[]) => {
    let data: IGroupAlert[] = [];
    alerts.map(item => {
      data.push(this.mappingObject(item));
    });
    return data;
  };
}
